import { Action } from "@mimber/schema"

/**
 * Action hierarchy levels (from least to most permissive)
 * READ < CREATE/SEND < UPDATE < DELETE < MANAGE
 */
const actionHierarchy: Record<Action, number> = {
  [Action.READ]: 1,
  [Action.CREATE]: 2,
  [Action.SEND]: 2,
  [Action.UPDATE]: 3,
  [Action.DELETE]: 4,
  [Action.MANAGE]: 5,
}

/**
 * Check if a user's granted action is sufficient for the required action
 * @param grantedAction - The action the user has permission for
 * @param requiredAction - The action being checked
 * @returns true if the granted action is >= required action in hierarchy
 *
 * @example
 * checkActionHierarchy(Action.MANAGE, Action.READ) // true
 * checkActionHierarchy(Action.READ, Action.DELETE) // false
 * checkActionHierarchy(Action.UPDATE, Action.UPDATE) // true
 */
export const checkActionHierarchy = (
  grantedAction: Action,
  requiredAction: Action
): boolean => {
  const grantedLevel = actionHierarchy[grantedAction] || 0
  const requiredLevel = actionHierarchy[requiredAction] || 0
  return grantedLevel >= requiredLevel
}
